import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

const AboutUs = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Hero Section */}
      <div className="relative w-full h-[280px] md:h-[350px] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/8532616/pexels-photo-8532616.jpeg?auto=compress&cs=tinysrgb&w=1200"
          alt="About Us"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white">About Us</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex-grow bg-white">
        <div className="max-w-5xl mx-auto px-8 py-16">
          <div className="space-y-6 text-center">
            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              Founded in 2020, <span className="font-semibold">H&U Apparel</span> is backed by over 30 years of family expertise in the textile industry. Our mission is simple: to provide the U.S. market with{' '}
              <span className="font-semibold">premium-quality blank apparel at competitive pricing.</span>
            </p>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              With a strong foundation in textile manufacturing, we've built lasting relationships with expert production teams who ensure every garment meets the highest standards of quality, consistency, and durability.
            </p>

            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              At <span className="font-semibold">H&U Apparel</span>, we pride ourselves on being a reliable partner for businesses, print shops, and brands nationwide—offering blanks that are made to perform, designed to last, and priced to support your growth.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
